module.exports = __webpack_public_path__ + "static/mb-best-promotion-air-solarcell-041ba4171ff1595106973ba3acab7168.webp";